export default {
    cart: {
      account: 'Pengaturan'
    },
    msg:{
      hello: 'hello world'
    },
    message:{
      hello:'hello <br/> world',
      hi:'%{msg} world'
    },
    en: {
      apple: 'no apples | one apple | {count} apples',
      banana: 'no bananas | {n} banana | {n} bananas'
    },
    tips: {
      cart_success: "Has been successfully added to the shopping cart",
      add_success: "Added successfully",
      empty: "Empty~",
      order_success: "Congratulations, the order is submitted successfully",
      chose: "please choose",
      un_pay_on_line: "Currently does not support online payment",
      area_not_empty: "Region cannot be empty",
      name_not_empty: "Name cannot be empty",
      address_not_empty: "Address cannot be empty",
      phone_not_empty: "Phone number is incorrect"
    },
    detail: {
      Delivery_method:'Delivery methods',
      Delivery_information:'Delivery information',
      carriage: 'Freight',
      Subtotal:'subtotal',
      CloseOrder:'order completed',
      Total:'total',
      jian:'Piece',
      mange:'management',
      surplus: 'Remaining',
      goods_detail: 'product details',
      cart: 'shopping cart',
      add_cart: 'add to Shopping Cart',
      buy_now: 'Buy now',
      paypaly_method:'Payment methods',
      paypaly1:'Cash on delivery',
      paypaly2:'payments',
      paypalyOut:'In development，wait patiently pls'
    },
    order: {
      freeFreight:'Freight free',
      allTotal:'Total price of goods',
      query:'Order inquiry',
      goods_info: 'Product information',
      pay_way: 'Choose delivery and payment method',
      offline: 'Cash on delivery',
      online: 'Online payments',
      pick_info: 'Delivery information',
      name_name: 'Name',
      name: "The recipient's name",
      phone_name: 'phone',
      phone: "Recipient's mobile number",
      area: 'Province, city, district, etc.',
      region: 'area',
      address_name: 'Address',
      address: 'Street number, floor room number and other information',
      offer_order: 'Submit Order',
    },
    data: {
      Recipient_name:'Recipient name',
      Recipient_nameTips:'Please fill in the real name of the recipient to ensure a smooth receipt',
      Select_M:'Choose a store',
      email:"Recipient's mailbox",
      Select_M_number:'Selected store number',
      Selected_store_name:'Selected store name',
      Shop_address:'Store address',
      address:'Please select an address',
      Choose_payment_method:'Selected payment method',
      default_address:'Taiwan',
    },
    indexdata:{
      index:'Home',
      list:'List',
      placeholder:'Enter search keywords',
      Return:'return'
    },
    Product_details_page: {
      guarantee:'Guarantee',
      guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
      numbertext:'Quantity',
      Select_product_specification:'Select product specifications',
      Package_selection: 'Package selection',
      Buy_now: 'Buy now'
    },
    newOrder:{
      Order_information:'Order information',
      Selection_of_delivery_and_payment_methods:'Choose delivery and payment method',
      Delivery_place:'Delivery location',
      tw:'Taiwan',
      Delivery_method:'Delivery methods',
      Sub_total:'subtotal',
      Freight_charges:'Freight',
      Total:'total',
      Go_to_checkout:'Go to checkout',
    },
    order3: {
      Total:'total  SGD',
      Delivery_information:'Delivery information',
      Freight_charges:'Freight',
      change:'change',
      Search_shop:'Search stores',
      Order_notes:'order notes',
      Payment_information:'Payment information',
      Payment_method_selected:'Selected payment method',
      Submit_order: 'Submit Order',
      xxdz:'Please enter detailed address',
      Select_address: 'Please select an address',
      Tell_the_seller:'Do you want to tell the seller?',
      freight:"Freight:",
      Spesifikasi_jualan_pendek:'The specification is sold out'
    },
    index:{
      placeholder:'Enter search keywords',
      index:'Index',
      list: 'List',
      language:'Language'
    },
    Guarantee:{
      num:'number',
      Pickup_method:'Support 7-11, Family Super Merchant Pickup',
      Guarantee:'Quality Assurance',
      Freight:'free shipping',
      Commodity_pic:'Commodity picture',
      Options:'Options',
      selected:'selected',
      Total_price:'Total order price',
      Finally_cope:'Finally_cope',
      message:'leave a message',
      region:'County',
      region_s:'Town/Township/District',
    },
    Pay:{
      language:'Cash on delivery',
      money:'SGD',
      to:'Jump to homepage in seconds',
      postcode:'Postcode',
      setMeal:'Combination package price',
      success:'successfully ordered!',
      time:'The merchant will automatically confirm your order within 10 minutes!',
      realMoney:'The amount actually paid',
      orderNumber:'Order number',
      waitFor:'The merchant did not ship, please wait patiently'
    },
    comment:{
      comment:'Post a comment',
      Praise:'Praise',
      Average:'Average',
      Badreview:'Bad review',
      submitcomments:'submit comments',
      PleaseEnteraComment:'Please enter a comment'
    },
    Toast:{
      inputName:'Please enter a name',
      inputPhone:'Please enter phone number',
      inputZip:'Please enter postcode',
      inputAddress:'Please enter detailed address',
      inputAlertAddress:'The address is not delivered, please change to another address',
    },
    contactUs:{
      callMe:'To learn more <br>,Pls contact the Messenger of our Facebook page!',
      afterShop:`Already shopping,Pls contact us: <br> Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'OK',
      shortSale:'The specification has been sold out',
    },
    ensure:{
      introduce:'Product introduction',
      Specifications:'Commodity specifications',
      ensure:'Commodity guarantee',
      di:'',
      commodity:'th item'
    },
    wuliu:{
      orderSearch:'订单查询',
      provide:'本數據由物流官方提供',
      OrderOrLogistics:'訂單號/物流單號(填寫一項即可查詢)',
      orderPlaceho:'填寫相關訊息查詢',
      query:'查询订单号',
      Tips:'温馨提示',
      Tipsinfo:'收到商品後有任何疑問請聯繫在線客服或發郵件至service325@hotmail.com。同時請告知您的姓名/聯繫方式/訂單編號，我們會快速的給您及時處理，祝您購物愉快！',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/en.js